import PropTypes from 'prop-types';
import {get as _get} from 'lodash';
import React from 'react';

import {ValuesDashRedChipWithTooltip} from '@utils/decorators';

export const getFieldsList = (event) => {
    return [
        {
            name: 'SR schedule state',
            value: <ValuesDashRedChipWithTooltip options={{
                value: event.sr_event.match?.schedule_state?.name,
                isRed: event.sr_event.match?.schedule_state?.is_shown_as_warning ?? false,
                tooltip: event.sr_event.match?.schedule_state?.description,
            }} />,
        },
        {
            id: _get(event, 'sr_event.match.match_status.id', null),
            name: 'Status',
            value: _get(event, 'sr_event.match.match_status.name', '-'),
        },
        {
            name: 'Started at',
            value: _get(event, 'sr_event.match.started_datetime', '-'),
        },
        {
            name: 'Ended at',
            value: _get(event, 'sr_event.match.ended_datetime', '-'),
        },
    ];
};

getFieldsList.propTypes = {
    event: PropTypes.shape({
        sr_event: PropTypes.shape({
            match: PropTypes.shape({
                match_status: PropTypes.shape({
                    name: PropTypes.string,
                }),
                started_datetime: PropTypes.string,
                ended_datetime: PropTypes.string,
            }),
        }),
    }).isRequired,
};

getFieldsList.defaultProps = {
    event: {
        sr_event: {
            match: {
                match_status: {
                    name: null,
                },
                started_datetime: null,
                ended_datetime: null,
            },
        },
    },
};
